<template lang="pug">
v-container
  .middle 
    v-card.mx-auto.rounded-lg(max-width="100%", elevation="10")
      v-card-title {{ $t('roadmap') }}
      v-card-text
        v-divider
        br
        br
        br
        v-container
          v-row(align="center", justify="space-around")
            v-btn.nufi-btn(depressed @click="openLink('http://roadmap.nufi.mx')") {{ $t('roadmap') }}
            v-btn.nufi-btn(depressed @click="openLink('http://roadmap.nufi.mx')") {{ $t('requestnewfeature') }}                                                       
            v-btn.nufi-btn(depressed @click="openLink('http://labs.nufi.mx')") {{ $t('labs') }}
</template>
<script>
import link from '@/mixins/link';

export default {
  mixins: [link],
}
</script>